"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatText = void 0;
const react_1 = __importDefault(require("react"));
const formatText = (text) => text.split('**').map((subText, idx) => 
// If the string contains '**' tags, the split should make all
// the bold ones end up on odd positions.
// Ex: '0 **1** 0 **1** 0' => [0, 1, 0, 1, 0]
idx % 2 === 1 ? (react_1.default.createElement("strong", { key: `${idx}-${subText}` }, subText)) : (subText));
exports.formatText = formatText;
